export default __webpack_public_path__ + "static/video-poster-0622194a23ef9b76f7bda369614d5232.png";